document.addEventListener("DOMContentLoaded", () => {
  const cartDrawer = document.getElementById("CartDrawer");
  const overlay = cartDrawer.querySelector(".cart-drawer__overlay");
  const closeButton = cartDrawer.querySelector(".cart-drawer__close");
  const itemsContainer = cartDrawer.querySelector("#CartDrawerItems");
  const totalEl = cartDrawer.querySelector("#CartDrawerTotal");

  function closeDrawer() {
    cartDrawer.classList.remove("active");
  }

  closeButton.addEventListener("click", closeDrawer);
  overlay.addEventListener("click", closeDrawer);

  async function fetchCart() {
    const res = await fetch("/cart.js");
    return res.json();
  }

  async function updateQuantity(line, quantity) {
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line, quantity }),
    });
    await renderCart();
  }

  async function removeItem(line) {
    await updateQuantity(line, 0);
  }

  function updateHeaderCartCount(itemCount) {
    const headerCartButton = document.getElementById("HeaderCartButton");
    if (headerCartButton) {
      headerCartButton.textContent = `cart (${itemCount})`;
    }
  }

  async function renderCart() {
    const cart = await fetchCart();
    itemsContainer.innerHTML = "";

    // Update header cart count
    updateHeaderCartCount(cart.item_count || 0);

    if (!cart.items || cart.items.length === 0) {
      itemsContainer.innerHTML = `<p class="empty">Your cart is empty.</p>`;
      if (totalEl) totalEl.textContent = "$0";
      return;
    }

    cart.items.forEach((item, index) => {
      const line = index + 1;
      const itemEl = document.createElement("div");
      itemEl.classList.add("cart-item");

      itemEl.innerHTML = `
        <div class="cart-item__details">
          <p class="cart-item__title">${item.product_title}</p>
          <p class="cart-item__price">$${parseFloat(
            (item.final_line_price / 100).toFixed(2)
          )}</p>
          ${
            item.options_with_values
              ?.map((opt) =>
                opt.value !== "Default Title"
                  ? `<p class="cart-item__variant">${opt.name}: ${opt.value}</p>`
                  : ""
              )
              .join("") || ""
          }
          <div class="cart-item__quantity">
            <button class="cart-item__quantity-btn decrease" data-line="${line}">−</button>
            <input type="number" class="cart-item__quantity-input" value="${
              item.quantity
            }" min="1" data-line="${line}">
            <button class="cart-item__quantity-btn increase" data-line="${line}">+</button>
          </div>

          <button class="cart-item__remove" data-line="${line}">x remove</button>
        </div>
        ${
          item.image
            ? `<img src="${item.image}" alt="${item.title}" class="cart-item__image" width="135" height="192"/>`
            : ""
        }
      `;

      const qtyInput = itemEl.querySelector(".cart-item__quantity-input");
      const minusBtn = itemEl.querySelector(".decrease");
      const plusBtn = itemEl.querySelector(".increase");
      const removeBtn = itemEl.querySelector(".cart-item__remove");

      minusBtn.addEventListener("click", () => {
        const newQty = Math.max(1, parseInt(qtyInput.value) - 1);
        qtyInput.value = newQty;
        updateQuantity(line, newQty);
      });

      plusBtn.addEventListener("click", () => {
        const newQty = parseInt(qtyInput.value) + 1;
        qtyInput.value = newQty;
        updateQuantity(line, newQty);
      });

      qtyInput.addEventListener("change", (e) => {
        const newQty = Math.max(1, parseInt(e.target.value));
        qtyInput.value = newQty;
        updateQuantity(line, newQty);
      });

      removeBtn.addEventListener("click", () => removeItem(line));

      itemsContainer.appendChild(itemEl);
    });

    if (totalEl) {
      totalEl.textContent = `$${parseFloat((cart.total_price / 100).toFixed(2))}`;
    }
  }

  // Initial render
  renderCart();

  // Listen for cart updates
  window.addEventListener("cart:updated", renderCart);

  // Global function to open drawer
  window.showCartDrawer = () => cartDrawer.classList.add("active");
});
